import axios from 'axios'
import { openDB } from 'idb'

const API_URL = process.env.REACT_APP_API_URL || 'https://vigilantapp.duckdns.org'

export const api = axios.create({
  baseURL: API_URL,
})

function getToken() {
  return localStorage.getItem('token') ||
    document.cookie.split(';').find(c => c.trim().startsWith('token='))?.split('=')[1] ||
    null
}

api.interceptors.request.use((config) => {
  const token = getToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

const getDB = () => openDB('vigilant', 1, {
  upgrade(db) {
    db.createObjectStore('auth')
  }
})

export const saveCredentials = async (email: string, password: string) => {
  const db = await getDB()
  await db.put('auth', email, 'email')
  await db.put('auth', password, 'password')
}

export const getSavedCredentials = async () => {
  const db = await getDB()
  const email = await db.get('auth', 'email')
  const password = await db.get('auth', 'password')
  return { email, password }
}

export const clearCredentials = async () => {
  const db = await getDB()
  await db.delete('auth', 'email')
  await db.delete('auth', 'password')
}

function setTokenCookie(token: string) {
  const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString()
  document.cookie = `token=${token}; expires=${expires}; path=/; SameSite=Strict`
}

export const login = async (email: string, password: string) => {
  const res = await api.post('/auth/login', { email, password })
  localStorage.setItem('token', res.data.token)
  localStorage.setItem('user', JSON.stringify(res.data.user))
  setTokenCookie(res.data.token)
  return res.data
}

export const register = async (email: string, password: string, name: string) => {
  const res = await api.post('/auth/register', { email, password, name })
  localStorage.setItem('token', res.data.token)
  localStorage.setItem('user', JSON.stringify(res.data.user))
  return res.data
}

export const logout = async () => {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
  await clearCredentials()
}

export const getUser = () => {
  const userData = localStorage.getItem('user')
  return userData ? JSON.parse(userData) : null
}
